import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, Card } from "../../layouts/PortalLayout";

// Friendly 403 shown when an authenticated admin opens a route their role does not
// grant (e.g. a Compliance user opening Finance). Replaces the old silent redirect
// to "/" so the user understands what happened and what to do.
const Forbidden: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "48px 16px" }}>
      <Card>
        <div style={{ maxWidth: 460, textAlign: "center", padding: "16px 8px" }}>
          <div style={{ fontSize: 40, lineHeight: 1, marginBottom: 12 }}>🔒</div>
          <h2 style={{ margin: "0 0 8px", fontSize: 20 }}>You don't have access to this page</h2>
          <p style={{ margin: "0 0 20px", color: "#6b7280", fontSize: 14, lineHeight: 1.6 }}>
            Your role doesn't include this area. If you need access, ask a platform admin to update
            your role.
          </p>
          <div style={{ display: "inline-flex", gap: 8 }}>
            <Button variant="secondary" onClick={() => navigate(-1)}>
              Go back
            </Button>
            <Button variant="primary" onClick={() => navigate("/")}>
              Go to dashboard
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Forbidden;
